import {
    createAsyncThunk,
    createSlice } from "@reduxjs/toolkit";
import { snpAxios } from "../components/global/api";
import {
  SUCCESS,
  getPreUrlAccordingToCart,
  CART_INITIAL_STATE,
  printDebugLog
} from "../constants/constant";

const restoBillConfigSlice = createSlice({
  name: "restobillConfig",
  initialState: {
    configs: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllConfigs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.configs = action.payload;
      })
      .addCase(fetchAllConfigs.rejected, (state, action) => {
        printDebugLog("error in fetching config: ", action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const fetchAllConfigs = createAsyncThunk(
  "restoBillConfig/fetchAllConfigs",
  async (configNames, thunkAPI) => {
    const state = thunkAPI.getState();
    const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
    const shopHash = state.setActiveShopHashReducer.activeShopHash;
    let fetchConfigUrl =
      storeApiUrl?.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(shopHash.cartType) +
      "get-multiple-configs";
    let data = {
      jcJson: {
        apiToken: CART_INITIAL_STATE?.apiToken,
        listConfigs: configNames,
        shopHash: shopHash?.id,
      },
    };

    try {
      const response = await snpAxios.post(fetchConfigUrl, data);
      if (response.data.status === SUCCESS) {
        const restoConfig = populateConfig(response.data.jcJson.mapConfigs);
        return restoConfig;
      } else {
        return thunkAPI.rejectWithValue({
          status: response.data.status,
          message: response.data.message,
        });
      }
    } catch (error) {
      console.error("Fetch Config Error: ", error);
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch bill config details"
      );
    }
  }
);

export const restoBillConfigReducer = restoBillConfigSlice.reducer;

const populateConfig = (configMap) => {
  //let config = {};
  console.log("configMap: ", configMap);
  // configMap && Object.entries(configMap).forEach(([key, value]) => {
  //     config[key] = "Yes" === value
  //    });
  const config = Object.fromEntries(
    Object.entries(configMap || {}).map(([key, value]) => [
      key,
      value === "Yes",
    ])
  );
  printDebugLog("config", config);
  return config;
};
